import React from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

export default ({ open, message, toggle }) => (
  <Modal isOpen={open} toggle={toggle}>
    <ModalBody>
      <div className="modal-logo">
        <img src="/static/image/Icona+Naming_NeerU_Blue.svg" />
      </div>
      {message}
    </ModalBody>
    <ModalFooter>
      <Button
        className="btn-neeru"
        style={{ marginTop: "0px" }}
        onClick={toggle}
      >
        OK
      </Button>
    </ModalFooter>
  </Modal>
);



// WEBPACK FOOTER //
// src/components/ModalSuccess.js